import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const DeviceService = {
  getDevices: () => {
    const url = REQUEST_URL.DEVICES;
    return RequestUtil.get({ url });
  },

  updateDevice: (deviceId: string, data: Record<string, unknown>) => {
    const url = `${REQUEST_URL.DEVICES}/${deviceId}`;
    return RequestUtil.put({ url, data });
  },

  triggerDeviceSync: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_SYNC.replace("{deviceId}", deviceId);
    return RequestUtil.post({ url, data: {} });
  },

  setCredentials: (deviceId: string, data: { username: string; password: string }) => {
    const url = REQUEST_URL.DEVICE_CREDENTIALS.replace("{deviceId}", deviceId);
    return RequestUtil.put({ url, data });
  },

  regenerateRecoveryCode: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_RECOVERY_CODE.replace("{deviceId}", deviceId);
    return RequestUtil.post({ url, data: {} });
  },

  revokeCredentials: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_CREDENTIALS.replace("{deviceId}", deviceId);
    return RequestUtil.delete({ url });
  },

  requestAttendanceLogs: (deviceId: string, date: string) => {
    const url = REQUEST_URL.DEVICE_ATTENDANCE_LOGS_REQUEST.replace(
      "{deviceId}",
      deviceId
    );
    return RequestUtil.post({ url, data: { date } });
  },

  requestEvidence: (
    deviceId: string,
    data: { from: string; to: string; employee?: string; flaggedOnly?: boolean }
  ) => {
    const url = REQUEST_URL.DEVICE_EVIDENCE_REQUEST.replace("{deviceId}", deviceId);
    return RequestUtil.post({ url, data });
  },

  listEvidenceRequests: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_EVIDENCE_REQUESTS.replace("{deviceId}", deviceId);
    return RequestUtil.get({ url });
  },

  listAttendanceLogs: (deviceId: string, date?: string) => {
    const base = REQUEST_URL.DEVICE_ATTENDANCE_LOGS.replace(
      "{deviceId}",
      deviceId
    );
    const url = date ? `${base}?date=${encodeURIComponent(date)}` : base;
    return RequestUtil.get({ url });
  },

  getAttendanceLogDetail: (reportId: string) => {
    const url = REQUEST_URL.DEVICE_ATTENDANCE_LOG_DETAIL.replace(
      "{reportId}",
      reportId
    );
    return RequestUtil.get({ url });
  },
};
